angular.module('webpanel').service('chromecast', function() {
	return {
		make: function(origin, id) {
			return new ChromecastJS(origin, id);
		},
		is: function(obj) {
			return (typeof obj === 'object' && obj instanceof ChromecastJS);
		}
	}
});